<template>
    <div>
        <v-container>
            <v-form>
                <v-row class="px-8">
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}</h2>
                </v-row>
                <v-row>
                    <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentcode')" type="text"
                            v-model="formData.pmassessmentrecordcode" class="v-input"
                            dense readonly background-color="#ffeab2"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentdesc')" type="text"
                            ref="pmassessmentrecorddesc" v-model="formData.pmassessmentrecorddesc" 
                            dense readonly class="v-input" background-color="#ffeab2"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentstartdate')" type="date" ref="startdate"
                            v-model="formData.startdate" 
                            dense readonly class="v-input" background-color="#ffeab2"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentenddate')" type="date" ref="enddate"
                            v-model="formData.enddate" 
                            dense readonly class="v-input" background-color="#ffeab2"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentcutoffdate')" type="date" ref="cutoffdate"
                            v-model="formData.cutoffdate" 
                            class="v-input" dense readonly background-color="#ffeab2"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-autocomplete outlined :label="$t('columns.status')" type="text" ref="statusid"
                            v-model="formData.statusid" :items="statusList"
                            class="v-input" dense readonly background-color="#ffeab2"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row v-if="false"><!-- hide for now, we just do rank first-->
                    <v-col cols="8" class="pb-n5 mt-n6">
                        <v-radio-group v-model="formData.ratingtype" row readonly class="v-input" background-color="#ffeab2">
                            <v-radio label="Rank" value=1></v-radio>
                            <v-radio label="Grid" value=2></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                        <v-autocomplete outlined :label="$t('pmassementrecord.pmassessmentratingoption')" type="text" ref="ratingid"
                            v-model="formData.ratingid" :items="ratingOptionList"
                            dense readonly class="v-input" background-color="#ffeab2"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentratingcode')"  type="text" v-model="formData.ratingcode" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('columns.remark')" type="text" ref="remark" v-model="formData.remark"
                            rows="1" dense readonly class="v-input" background-color="#ffeab2">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="8" class="pb-n5 mt-n6">
                        <v-autocomplete outlined :label="$t('pmassementrecord.pmassessmentcalculationmethod')" type="text" ref="pmassecalmethodid"
                            v-model="formData.pmassecalmethodid" :items="calMethodList"
                            dense readonly class="v-input" background-color="#ffeab2"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row v-if="isEdit && formData.startdate != null" >
                        <app-table
                            v-bind:parentObject="{
                                tabHeader: this.tabHeader,
                                detailItem: this.parentObject.pmAssessmentRecordReviewList,
                                pmassessmentrecordid: this.parentObject.data.id,
                                startdate: this.formData.startdate,
                                enddate: this.formData.enddate,
                                pmassecalmethodid: this.formData.pmassecalmethodid,
                                isAdvanceEdit:this.parentObject.isAdvanceEdit,
                                pmassecalmethodname: this.formData.pmassecalmethodname,
                            }"
                        />
                </v-row>
                <v-row v-if="parentObject.pmAssessmentRecordReviewList && parentObject.pmAssessmentRecordReviewList.length > 0">
                    <v-col cols="2" sm="2">
                        <v-btn color="primary" v-on:click="calculateAndSaveHandler">Calculate & Save</v-btn>
                    </v-col>
                    <v-col cols="2" sm="2" v-if="recordExists">
                        <v-btn color="primary" v-on:click="viewDetailsHandler">View Details</v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
        <div v-if="isConfirm">
            <app-confirm
                v-bind:parentObject="{
                messageConfirm: this.messageConfirm,
                isConfirm: this.isConfirm,
                }"
                v-on:confirm="handleConfirm(true)"
                v-on:cancelConfirm="handleConfirm(false)"
            />
        </div>
    </div>
</template>

<script>
// This is used by AdvanceEdit to display all fields as readonly with 2 custom buttons
import CRUDTable from "./CRUDTable";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-table": CRUDTable,
        "app-confirm": ConfirmDialog,
    },

    computed: {
        canShowButtons() {
            return this.recordExists; // Show "View Details" only if record exists
        }
    },

    data() {
        return {
            recordExists: false, // Track if there is an existing record

            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                pmassessmentrecordcode: this.parentObject?.data?.pmassessmentrecordcode || "",
                pmassessmentrecorddesc: this.parentObject?.data?.pmassessmentrecorddesc || "",
                startdate: this.parentObject?.data?.startdate || "",
                enddate: this.parentObject?.data?.enddate || "",
                cutoffdate: this.parentObject?.data?.cutoffdate || "",
                statusid: this.parentObject?.data?.statusid || "",
                ratingtype: 1,
                ratingid: this.parentObject?.data?.ratingid || "",
                ratingcode: this.parentObject?.data?.ratingcode || "",
                remark: this.parentObject?.data?.remark || "",
                pmassecalmethodid: this.parentObject?.data?.pmassecalmethodid || "",
                stamp: this.parentObject?.data?.stamp || "",
                userid: this.parentObject?.data?.userid || "",
                pmassecalmethodname: this.parentObject?.data?.calculationmethodname || "",
            },

            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '150px', sortable: false},
                { text: this.$t('pmassementrecord.reviewexercisecode'), value: 'reviewcode', width: '150px', sortable: false},
                { text: this.$t('performancereport.reviewexercisedescription'), value: 'reviewdesc', width: '250px', sortable: false },
                { text: "%", value: 'percentage', width: '20px', sortable: false },
                { text: this.$t('pmassementrecord.reviewexerciseperiodfrom'), value: 'startdate', width: '150px', sortable: false },
                { text: this.$t('pmassementrecord.reviewexerciseperioduntil'), value: 'enddate', width: '150px', sortable: false},
            ],

            errMsg: '',
            isErr: false,
            isEdit: this.parentObject?.isEdit || false,
            isAdvanceEdit: this.parentObject?.isAdvanceEdit || false,
            ratingOptionList: [],
            ratingOptionFull: [],
            calMethodList: [],
            calMethodFull: [],
            statusList: [],
            statusFull: [],
            confirmProceed: true,//default true
            isConfirm: false,
            messageConfirm:'',
        };
    },

    methods: {
        async loadRankMappingListHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: '/rankmapset/active/all' });
                this.ratingOptionFull = res.data.rec;
                this.ratingOptionList = res.data.rec.map(item => ({
                    text: item.description,
                    value: item.id,
                }));

                if (this.formData.ratingid) {
                    this.changeRatingOption(this.formData.ratingid);
                }
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
            }
        },

        changeRatingOption(id) {
            const item = this.ratingOptionFull.find(item => item.id === id);
            this.formData.ratingcode = item ? item.rankmapset : "";
        },

        async loadPmAsseStatusListHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: '/pmassementstatus/all' });
                this.statusList = res.data.rec.map(item => ({
                    text: item.statusdesc,
                    value: item.id,
                }));
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
            }
        },

        async loadCalMethodListHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: '/pmasscalmethod/all' });
                this.calMethodList = res.data.rec.map(item => ({
                    text: item.calculationname,
                    value: item.id,
                }));
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
            }
        },

        async checkIfRecordExists() {
            const recordId = this.parentObject?.pmAssessmentRecordReviewList?.[0]?.pmassessmentrecordid;

            if (!recordId) {
                //console.warn("⚠️ No pmassessmentrecordid found, skipping check.");
                return; // Prevents unnecessary API call if ID is missing
            }

            try {
                const res = await this.$store.dispatch("get", {
                    url: `/checkAssessmentRecordDetail/${recordId}`
                });

                this.recordExists = res.data.exists;
            } catch (err) {
                console.error("❌ Error checking record:", err);
            }
        },

        async calculateAndSaveHandler() {
            const recordId = this.parentObject?.pmAssessmentRecordReviewList?.[0]?.pmassessmentrecordid;
            
            if (!recordId) {
                alert("⚠️ Missing pmassessmentrecordid. Cannot proceed.");
                return;
            }

            // ⚠️ If a record already exists, show a confirmation dialog
            if (this.recordExists) {
                this.messageConfirm = this.$t('pmassementrecord.overwriteconfirm');
                this.confirmProceed = await this.waitForUserConfirmation(); // ⏳ Wait for confirmation

                if (!this.confirmProceed) {
                    return; // Stop execution if user cancels
                }
            }
            // if(this.parentObject.data.pmassecalmethodid == 1){//cal method id =1 , which is = Percentage
            if(this.parentObject.data.calculationmethodname == "Percentage"){
                try {
                    const res = await this.$store.dispatch("post", {
                        url: "/calculateAndSaveAssessmentRecordDetailByPercentage",
                        payload: {
                            pmassessmentrecordid: recordId,
                            updatedby: this.$store.getters.userId
                        }
                    });

                    if (res.data.error) {
                        console.error("❌ Error:", res.data.error);
                        this.isErr = true;
                        this.errMsg = res.data.error;
                    } else {
                        this.$router.push({ name: "performanceassessmentrecorddetail", params: { id: recordId } });
                    }
                } catch (err) {
                    console.error("❌ API Call Failed:", err);
                    this.isErr = true;
                    this.errMsg = "Failed to process calculation.";
                }
            }
            // else if(this.parentObject.data.pmassecalmethodid == 2)//cal method id= 2, which is = Time Weighted Average
            else if(this.parentObject.data.calculationmethodname == "Time Weighted Average")
            {
                try {
                    const res = await this.$store.dispatch("post", {
                        url: "/calculateAndSaveAssessmentRecordDetailByTWA",
                        payload: {
                            pmassessmentrecordid: recordId,
                            updatedby: this.$store.getters.userId
                        }
                    });

                    if (res.data.error) {
                        console.error("❌ Error:", res.data.error);
                        this.isErr = true;
                        this.errMsg = res.data.error;
                    } else {
                        this.$router.push({ name: "performanceassessmentrecorddetail", params: { id: recordId } });
                    }
                } catch (err) {
                    console.error("❌ API Call Failed:", err);
                    this.isErr = true;
                    this.errMsg = "Failed to process calculation.";
                }
            }
            else
            {   //if calmethodid 1 and 2 not found OR their name not found
                console.error("Something went wrong, cannot get calculation method,missing calmethodid");
                this.isErr = true;
                this.errMsg = "Failed to process calculate.";
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        waitForUserConfirmation() {
            return new Promise((resolve) => {
                this.isConfirm = true; // Show confirmation dialog

                // Attach event listeners dynamically
                this.handleConfirm = (confirmed) => {
                    this.isConfirm = false; // Close dialog
                    resolve(confirmed); // Resolve promise with user decision
                };
            });
        },

        viewDetailsHandler() {
            const recordId = this.parentObject?.pmAssessmentRecordReviewList?.[0]?.pmassessmentrecordid;

            if (!recordId) {
                console.warn("⚠️ No pmassessmentrecordid found, cannot view details.");
                this.isErr = true;
                this.errMsg = "Failed to load  record.";
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                return;
            }

            this.$router.push({ name: "performanceassessmentrecorddetail", params: { id: recordId } });
        },

    },

    async mounted() {
        try {
            await this.loadRankMappingListHandler();
            await this.loadPmAsseStatusListHandler();
            await this.loadCalMethodListHandler();
            await this.checkIfRecordExists();
        } catch (error) {
            console.error("❌ Error loading data:", error);
        }
    }
};
</script>